module.exports = __webpack_public_path__ + "static/media/case_view_add_a_comment.ba0e671c.png";